import { type AttributeWidgetSource, type Widget, WidgetSourceType } from './core-widget-types';

export function getWidgetSource(widget: Pick<Widget, 'sources'>): string | undefined {
  return getWidgetAttributeSource(widget)?.value;
}

function getWidgetAttributeSource(
  widget: Pick<Widget, 'sources'>,
): AttributeWidgetSource | undefined {
  const source = widget.sources[0];

  if (source?.type !== WidgetSourceType.ATTRIBUTE) {
    return undefined;
  }

  return source;
}

export function getWidgetBySource<TWidget extends Pick<Widget, 'sources'>>(
  widgets: TWidget[] | undefined,
  widgetSource: string,
): TWidget | undefined {
  return widgets?.find((widget) => getWidgetSource(widget) === widgetSource);
}

type AttributeDefinitionLike = {
  name: string;
  type: AttributeWidgetSource['metadata']['attributeType'];
};

export function getWidgetByAttributeDefinition<TWidget extends Pick<Widget, 'sources'>>(
  widgets: TWidget[] | undefined,
  attributeDefinition: AttributeDefinitionLike,
): TWidget | undefined {
  return widgets?.find((widget) => {
    const source = getWidgetAttributeSource(widget);

    return (
      source?.value === attributeDefinition.name &&
      source.metadata.attributeType === attributeDefinition.type
    );
  });
}
